import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/vetdata_animals.webp'


const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { style: {"font-size":"20px","font-weight":"300","line-height":"1.6"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    style: _normalizeStyle({ width: _ctx.$vuetify.display.lgAndUp ? '60%' : '100%', paddingTop: '50px' })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "pl-7" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { sm: "12" }, {
            default: _withCtx(() => [
              (_ctx.loggedIn && _ctx.permissions.length > 0)
                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        small: "",
                        color: "primary",
                        onClick: _ctx.logout
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('login.button.logout')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "mb-6",
                        align: "start",
                        justify: "end"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "auto",
                            class: "d-flex justify-center justify-sm-end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tooltip, {
                                location: "bottom",
                                color: "secondary"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn, _mergeProps(props, {
                                    class: "mx-2",
                                    color: "primary",
                                    onClick: _ctx.handleLoginTotp
                                  }), {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('login.button.login')) + " Authenticator ", 1)
                                    ]),
                                    _: 2
                                  }, 1040, ["onClick"])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("p", {
                                      innerHTML: _ctx.$t('login.description.login.totp')
                                    }, null, 8, _hoisted_1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "auto",
                            class: "d-flex justify-center justify-sm-end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tooltip, {
                                location: "bottom",
                                color: "secondary"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn, _mergeProps(props, {
                                    class: "mx-2",
                                    color: "primary",
                                    onClick: _ctx.handleLoginSms
                                  }), {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('login.button.login')) + " SMS ", 1)
                                    ]),
                                    _: 2
                                  }, 1040, ["onClick"])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("p", {
                                      innerHTML: _ctx.$t('login.description.login.sms')
                                    }, null, 8, _hoisted_2)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "auto",
                            class: "d-flex justify-center justify-sm-end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tooltip, {
                                location: "bottom",
                                color: "secondary"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn, _mergeProps(props, {
                                    class: "mx-2",
                                    color: "primary",
                                    to: { name: 'Registration' },
                                    link: ""
                                  }), {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('login.button.registration')), 1)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("p", {
                                      textContent: _toDisplayString(_ctx.$t('login.description.registration'))
                                    }, null, 8, _hoisted_3)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.$te('login.description.2fa.text'))
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                innerHTML: _ctx.$t('login.description.2fa.text')
                              }, null, 8, _hoisted_4),
                              _cache[0] || (_cache[0] = _createTextVNode("  ")),
                              _createElementVNode("span", {
                                innerHTML: _ctx.$t('login.description.2fa.link')
                              }, null, 8, _hoisted_5)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "mt-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "6",
                                class: "d-flex flex-column justify-start align-start"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("h1", {
                                      class: "mb-3",
                                      textContent: _toDisplayString(_ctx.$t('login.subtitle'))
                                    }, null, 8, _hoisted_6),
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('login.description.one')) + " " + _toDisplayString(_ctx.$t('login.description.two')), 1)
                                  ]),
                                  _createVNode(_component_v_btn, {
                                    class: "mt-4",
                                    style: {"width":"200px"},
                                    small: "",
                                    color: "secondary",
                                    onClick: _ctx.forwardToVetdata
                                  }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                      _createTextVNode(" www.vetdata.ch ")
                                    ])),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_img, {
                                    style: {"width":"100%","height":"auto","border":"1px solid #ccc","display":"flex","align-items":"center","justify-content":"center","background-color":"#f5f5f5"},
                                    src: _imports_0
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}